import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from "@mui/material";

import { theme } from "../../../../../../assets";

const s4Style = {
    color: "rgba(62, 55, 78, 0.87)",
    fontFamily: "Noto Sans",
    fontSize: "0.875rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.125rem",
    letterSpacing: "0.0044rem",
};

export const EditActivityProfileDialog = ({
    handleCancel,
    handleUpdateActivityProfilesFromUser,
    isLoading,
    open,
}: {
    open: boolean;
    handleCancel: () => void;
    handleUpdateActivityProfilesFromUser: () => void;
    isLoading: boolean;
}) => {
    return (
        <Dialog
            open={open}
            sx={{
                ".css-1il5h00-MuiPaper-root-MuiDialog-paper": {
                    maxWidth: "50rem",
                },
            }}
        >
            <DialogContent
                sx={{
                    width: "100%",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{ marginTop: "1vh", p: "1rem 1.5rem" }}
                >
                    Atualização de Perfil
                </Typography>

                <DialogContent>
                    <Typography sx={s4Style}>
                        Você selecionou Perfis de Atividade que não eram
                        inicialmente deste colaborador. <br /> <br />
                        Deseja atualizar os perfis desse colaborador?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="text"
                        onClick={handleCancel}
                        sx={{
                            color: theme.purple500,
                            fontWeight: 500,
                            fontSize: "0.875rem",
                        }}
                    >
                        CANCELAR
                    </Button>
                    <Button
                        onClick={handleUpdateActivityProfilesFromUser}
                        variant="contained"
                        disabled={isLoading}
                        sx={{
                            color: theme.white,
                            fontWeight: 500,
                            fontSize: "0.875rem",
                        }}
                    >
                        CONFIRMAR
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};
